// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"80a6139b","513":"c5b87f55","703":"ed62f0cf","787":"2013a1cb"}[chunkId] + ".chunk.js";
};